module.exports = __webpack_public_path__ + "img/tarj2-2.a9b6c81e.png";